<template>
  <div>
    <XField
      :errors="error === null ? null : [error]"
      :errorStyle="formFieldsErrorStyle"
    >
      <div :style="labelStyle">
        <label
          v-if="label"
          :style="labelStyle"
        >
          {{ label }}
          <slot name="hint" />
        </label>

        <div
          id="card-element"
        />
      </div>
    </XField>

    <div
      class="flex">
      <div
        class="w-1/2">
        <img src="@/platform/assets/images/credit-cards.png">
      </div>
      <div
        class="w-1/2 text-right">
        <img src="@/platform/assets/images/powered-by-stripe.png">
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    label: {
      type: String
    },
    labelStyle: {
      type: Object
    },
    errorStyle: {
      type: Object
    },
    stripeKey: {
      type: String,
      required: true
    },
    stripeClientSecret: {
      type: String,
      required: true
    },
    buyerFullName: {
      type: String
    }
  },

  data () {
    return {
      stripe: null,
      stripeCard: null,
      isCardCompleted: false,
      error: null
    }
  },

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    formFieldsErrorStyle () {
      return {
        position: 'relative',
        top: '-3px',
        backgroundColor: this.errorStyle.backgroundColor,
        color: this.errorStyle.color,
        margin: '0',
        padding: '0.5em',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        fontWeight: '500'
      }
    }
  },

  created () {
    this.stripe = window.Stripe(this.stripeKey)
  },

  mounted () {
    this.mountInput()
  },

  methods: {
    mountInput () {
      const elements = this.stripe.elements()

      this.stripeCard = elements.create('card', {
        classes: {
          base: DEFAULT_INPUT_CLASSES
        }
      })

      this.stripeCard.mount('#card-element')

      this.stripeCard.addEventListener('change', ({ complete, error }) => {
        this.isCardCompleted = complete
        this.error = error ? error.message : null
      })
    },

    async pay () {
      const { paymentIntent, error } = await this.stripe.confirmCardPayment(
        this.stripeClientSecret,
        {
          payment_method: {
            card: this.stripeCard,
            billing_details: {
              name: this.buyerFullName
            }
          }
        }
      )

      if (error) {
        this.error = error.message
        return false
      }

      if (paymentIntent.status === 'succeeded') {
        return true
      }

      this.error = 'No se ha podido completar el pago. Inténtelo de nuevo mas tarde.'
      return false
    }
  }
}

const DEFAULT_INPUT_CLASSES = [
  'w-full',
  'bg-white',
  'rounded',
  'border',
  'border-solid',
  'border-grey-80',
  'px-3',
  'py-2',
  'outline-none',
  'focus:shadow-outline-info',
  'focus:border-info-50',
  'text-grey-40',
  'appearance-none'
].join(' ')

</script>
